import { assertInInjectionContext, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '@tsin-core/store/auth/auth.state';

const canActivateFn: CanActivateFn = () => {
  assertInInjectionContext(canActivateFn);
  const router: Router = inject(Router);
  const store: Store = inject(Store);

  const isOtpReady = store.selectSnapshot(AuthState.getEmail);

  if (!!isOtpReady) {
    return true;
  }

  return router.parseUrl('/login');
};

export const preOtpGuard: CanActivateFn = (route, state) => {
  return canActivateFn(route, state);

};
